export default "__VITE_ASSET__DPC31Auu__"